import { useEffect } from "react";

const usePreventZoom = () => {
  useEffect(() => {
    // Блокировка gesture-событий для iOS
    const preventGesture = (e: Event) => {
      e.preventDefault();
    };

    // Блокировка масштабирования на touch-устройствах (pinch-to-zoom)
    const preventTouchZoom = (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    // Блокировка масштабирования через клавиатуру (Ctrl/Cmd + '+', '-', '=', '0')
    const preventKeyZoom = (e: KeyboardEvent) => {
      const blockedKeys = ['+', '-', '=', '0'];
      if ((e.ctrlKey || e.metaKey) && blockedKeys.includes(e.key)) {
        e.preventDefault();
      }
    };

    // Блокировка масштабирования через ctrl+колёсико мыши
    const preventWheelZoom = (e: WheelEvent) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    };

    document.addEventListener("touchmove", preventTouchZoom, { passive: false });
    document.addEventListener("gesturestart", preventGesture, { passive: false });
    document.addEventListener("gesturechange", preventGesture, { passive: false });
    document.addEventListener("gestureend", preventGesture, { passive: false });
    document.addEventListener("keydown", preventKeyZoom, { passive: false });
    document.addEventListener("wheel", preventWheelZoom, { passive: false });

    return () => {
      document.removeEventListener("touchmove", preventTouchZoom);
      document.removeEventListener("gesturestart", preventGesture);
      document.removeEventListener("gesturechange", preventGesture);
      document.removeEventListener("gestureend", preventGesture);
      document.removeEventListener("keydown", preventKeyZoom);
      document.removeEventListener("wheel", preventWheelZoom);
    };
  }, []);
};

export default usePreventZoom;
